import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FabrikatDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fabrikat-dto';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FabrikatService } from 'src/app/api/services/fabrikat.service';
import { ProduktEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/produkt-enum';
import { StamdataStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/stamdata-status-enum';
import { StamdataStatusService } from '../../shared/stamdata-status.service';
import { StamdatastatusModel } from '../../shared/stamdatastatus.model';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ModelEditDialogComponent } from '../../modeller/model-edit-dialog/model-edit-dialog.component';
import { EditFabrikatDialogData } from 'src/app/components/aftale/models';

@Component({
  selector: 'app-fabrikat-edit-dialog',
  templateUrl: './fabrikat-edit-dialog.component.html',
  styleUrls: ['./fabrikat-edit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FabrikatEditDialogComponent implements OnInit {
  form: UntypedFormGroup;
  produkter: string[] = [];
  fabrikatstatus: Array<StamdatastatusModel> = [];
  fabrikat: FabrikatDto;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: FabrikatService,
    private statusservice: StamdataStatusService,
    public dialogRef: MatDialogRef<ModelEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditFabrikatDialogData,
  ) {
    this.fabrikat = data.fabrikat;
  }

  ngOnInit(): void {
    this.produkter = this.EnumToArray(ProduktEnum);
    this.fabrikatstatus = this.EnumToArray(StamdataStatusEnum).map((p) => {
      return { value: p, name: this.statusservice.stamdatastatus(p) };
    });

    this.form = this.formBuilder.group({
      produktId: [this.data.fabrikat.produktId, [Validators.required]],
      name: [this.data.fabrikat.name, [Validators.required, Validators.minLength(3)]],
      fabrikatstatus: [this.data.fabrikat.fabrikatstatus, [Validators.required]],
    });
  }

  async update() {
    if (!this.form.valid) return;

    let data: FabrikatDto = Object.assign({}, this.data, this.form.value);
    data.produkt = {};

    let result: FabrikatDto = null;

    if (this.data.fabrikat.id) {
      result = await this.service
        .updateFabrikat({
          fabrikatId: this.data.fabrikat.id,
          caller: EGIS_SERVICE_CALLER,
          body: data,
        })
        .toPromise();
    } else {
      result = await this.service.createFabrikat({ caller: EGIS_SERVICE_CALLER, body: data }).toPromise();
    }
    this.dialogRef.close(result);
  }

  EnumToArray(enumme) {
    return Object.keys(enumme).map((key) => enumme[key]);
  }
}
